import { DATE_FORMATS } from "../../../../../constants/date/date.js";
import { parseISO, differenceInMinutes, format, isEqual } from "date-fns";
import { getOpenAvailyBookingFromAppointment } from "../../helpers/appointment.js";
import { EMPLOYEE_ROLES, MIN_DURATION } from "./appointment-form.constants.js";
import "../../appointment-details.types.js";
const initialEmployeeRoles = EMPLOYEE_ROLES.reduce(
  (acc, role) => ({
    ...acc,
    [role]: []
  }),
  {}
);
const parseInitialValues = (data) => {
  var _a, _b;
  if (!data)
    return {
      duration: MIN_DURATION,
      patientReferenceId: "",
      referenceId: "",
      employeeReferenceId: null,
      startTime: null,
      title: "",
      treatmentReferenceId: "",
      comment: "",
      randomPractitioner: null,
      openedForOnlineBooking: false,
      overbooked: false,
      employeeByRole: initialEmployeeRoles
    };
  if ("startTime" in data) {
    const startTime = data.startTime ? parseISO(data.startTime) : null;
    const duration2 = data.endTime && data.startTime && differenceInMinutes(parseISO(data.endTime), parseISO(data.startTime)) || MIN_DURATION;
    return {
      duration: duration2,
      patientReferenceId: ((_a = data.patient) == null ? void 0 : _a.referenceId) ?? "",
      referenceId: data.referenceId ?? "",
      employeeReferenceId: data.employeeReferenceId ?? null,
      startTime,
      title: data.title ?? "",
      treatmentReferenceId: data.treatmentReferenceId ?? "",
      openedForOnlineBooking: getOpenAvailyBookingFromAppointment(data == null ? void 0 : data.blocking),
      comment: data.comment ?? "",
      employeeByRole: (data == null ? void 0 : data.employeeByRole) ?? initialEmployeeRoles,
      overbooked: false,
      ...data.patient && {
        patient: {
          ...data.patient
        }
      }
    };
  }
  const duration = "duration" in data ? (data == null ? void 0 : data.duration) ?? (data.end && data.start && differenceInMinutes(data.end, data.start) || MIN_DURATION) : MIN_DURATION;
  return {
    duration,
    patientReferenceId: ((_b = data.patient) == null ? void 0 : _b.referenceId) ?? "",
    referenceId: "",
    employeeReferenceId: "employeeReferenceId" in data ? data.employeeReferenceId ?? null : null,
    startTime: "start" in data ? data.start ?? null : /* @__PURE__ */ new Date(),
    title: data.title ?? "",
    treatmentReferenceId: data.treatmentReferenceId ?? "",
    openedForOnlineBooking: "blocking" in data ? getOpenAvailyBookingFromAppointment(data == null ? void 0 : data.blocking) : false,
    overbooked: false,
    comment: (data == null ? void 0 : data.comment) ?? "",
    openAppointmentReferenceId: "openAppointmentReferenceId" in data ? data == null ? void 0 : data.openAppointmentReferenceId : "",
    employeeByRole: "employeeByRole" in data ? (data == null ? void 0 : data.employeeByRole) ?? initialEmployeeRoles : initialEmployeeRoles,
    ...data.patient && {
      patient: {
        ...data.patient
      }
    }
  };
};
const getRandomEmployeeId = (employees = []) => {
  const randomIndex = Math.floor(Math.random() * employees.length);
  return employees[randomIndex] ?? null;
};
const getSelectedSlot = (date, slots) => {
  var _a, _b;
  if (!date)
    return null;
  return (_b = (_a = slots == null ? void 0 : slots.filter(({ date: slotDate }) => slotDate === format(date, DATE_FORMATS.ISO_SHORT))) == null ? void 0 : _a[0]) == null ? void 0 : _b.slots.find(({ start }) => isEqual(parseISO(start), date));
};
export {
  getRandomEmployeeId,
  getSelectedSlot,
  initialEmployeeRoles,
  parseInitialValues
};
